<div class="multi-select">
    <section class="list">
        <h3>
            {{ 'grouping.edit.allowedList.title.shortLabel' | translate }}
        </h3>
        <mat-form-field>
            <mat-label>{{ 'grouping.edit.filter.shortLabel' | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="filterValue">
        </mat-form-field>

        <mat-list class="available-list">
            <mat-list-item *ngFor="let organism of availableOrganisms | arrayTextFilter: filterValue">
                <span mat-line>{{ organism.text.shortLabel }}</span>
                <button mat-icon-button type="button" [color]="isSelected(organism.code) ? 'accent' : 'primary'"
                    (click)="onSelectOrganism(organism.code)"
                    [matTooltip]="'grouping.edit.selectedList.delete.shortLabel' | translate">
                    <mat-icon aria-label="checkbox">{{ isSelected(organism.code) ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                </button>
            </mat-list-item>
        </mat-list>
    </section>

    <section class="list">
        <h3>
            {{ 'grouping.edit.selectedList.title.shortLabel' | translate }}
        </h3>
        <mat-list class="selected-list">
            <mat-list-item *ngFor="let organism of selectedOrganisms">
                <span mat-line>
                    {{ organism.text.shortLabel }}
                </span>
                <button mat-icon-button color="accent" type="button"
                    (click)="onDeleteOrganism(organism.code)"
                    [matTooltip]="'grouping.edit.selectedList.delete.shortLabel' | translate">
                    <mat-icon aria-label="Delete">delete</mat-icon>
                </button>
            </mat-list-item>
        </mat-list>
        <p class="error-message" *ngIf="selectedOrganisms && selectedOrganisms.length < minSelected">
            {{ 'grouping.edit.selectedList.empty.summary' | translate: {min: minSelected } }}
        </p>

        <div class="actions">
            <button mat-raised-button color="accent"
                (click)="onCleanSelected()"
                [disabled]="!selectedOrganisms || !selectedOrganisms.length">
                <mat-icon aria-label="Delete">delete</mat-icon>
                {{ 'grouping.edit.selectedList.clean.shortLabel' | translate }}
            </button>
        </div>
    </section>
</div>
